import { render, staticRenderFns } from "./OrderChangedPriceComponent.vue?vue&type=template&id=4197f754"
import script from "./OrderChangedPriceComponent.vue?vue&type=script&lang=js"
export * from "./OrderChangedPriceComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderChangedPriceComponent.vue?vue&type=style&index=0&id=4197f754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports